export enum ECollectorType {
  BILLING = 1,
  PAYMENT_RECEIVED = 2,
  PAYMENT_IN = 3,
}

export enum EPaymentType {
  BANK_TRANSFER = 1,
  CHEQUE = 2,
}

export enum EPaymentReceivedStatus {
  POD = 1,
  BILLED = 2,
  RECEIVED = 3,
  DONE = 4,
}
